import React from 'react'
import { fileUrl } from '../functions/fileUrl'
import { splitDay } from '../functions/formatDays'
import { bildMasse } from '../../lib/functions/bildMasse'

// Die Kachel einer Messe, wie auf der Live-Seite: Bildflaeche mit tuerkisem
// Streifen, darunter ein dunkler Balken mit Name, Ort und je Messetag der
// grossen Tageszahl neben Monat, Jahr und Oeffnungszeit.
//
// Eine Komponente fuer beide Orte — die Uebersicht und die Kachelreihe des
// Shortcodes. Vorher gab es zwei Fassungen, und der Uebersicht fehlte die
// Bildflaeche samt Streifen (#107).
//
// Der einzige echte Unterschied zwischen den Orten ist die Art des Verweises:
// die Uebersicht liegt im Router der Event-App und benutzt dessen Link, die
// Startseite gehoert nicht dazu und braucht ein gewoehnliches a. Der Verweis
// wird darum hereingegeben statt hier festgelegt; beide Fassungen nehmen das
// Ziel als `to`.
const EventCard = ({ event, LinkComponent }) => (
    <li className="events-card">
        <LinkComponent className="events-card-inner" to={`/events/${event.slug}/`}>
            {/* Die Flaeche steht immer, auch ohne Bild: sie traegt den Streifen
                und den grauen Platzhalter. */}
            <div className="events-card-imagepart">
                {event.heroImage && (
                    <img className="events-card-image" src={fileUrl(event.heroImage.fileId)} alt="" loading="lazy" decoding="async" {...bildMasse(event.heroImage)} />
                )}
            </div>
            <div className="events-card-body">
                <h3 className="events-card-name">{event.name}</h3>
                {event.venue?.name && <p className="events-card-venue">{event.venue.name}</p>}
                <ul className="events-card-days">
                    {(event.days || []).map(day => {
                        const { dayNumber, monthYear, time } = splitDay(day)
                        return (
                            <li key={day.date}>
                                <span className="events-card-daynumber">{dayNumber}</span>
                                <span className="events-card-daytext">{monthYear}{time ? ` · ${time}` : ''}</span>
                            </li>
                        )
                    })}
                </ul>
            </div>
        </LinkComponent>
    </li>
)

export default EventCard
